import { createContext, useContext, useEffect, useState } from 'react';

import schema from './schema';

const API_URL = process.env.REACT_APP_API_URL;

export const api = (token) => {
  return schema(API_URL, window.pipe, token);
};

const APIContext = createContext();

export const APIProvider = ({ children }) => {

  /*
   * API Token
   */

  const KEY_TOKEN = 'token';

  const [ token, setToken ] = useState(() => {
    return localStorage.getItem(KEY_TOKEN) || '';
  });

  useEffect(() => {
    localStorage.setItem(KEY_TOKEN, token || '');
  }, [token]);

  /*
   * Cookie consent
   */

  const KEY_CONSENT = 'consent';

  const [ consent, setConsent ] = useState(() => {
    return localStorage.getItem(KEY_CONSENT) || '';
  });

  useEffect(() => {
    localStorage.setItem(KEY_CONSENT, consent || '');
  }, [consent]);

  /*
   * Final context
   */

  const context = {
    token, setToken,
    consent, setConsent,
  };

  return (
    <APIContext.Provider value={context}>
      {children}
    </APIContext.Provider>
  );
};

export const useAPIContext = () => useContext(APIContext);